import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Table, Button, Space, Tag, Popconfirm, message } from 'antd';

const { Title, Paragraph } = Typography;

const AgencyRegistrations = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    // TODO: Replace with real API call when backend endpoint exists
    setLoading(true);
    const timer = setTimeout(() => {
      setData([
        { id: 101, name: 'BlueSky Media', email: 'apply@bluesky.com', status: 'pending', submitted_at: '2025-08-01' },
        { id: 102, name: 'Delta Ads', email: 'contact@deltaads.com', status: 'pending', submitted_at: '2025-08-05' },
      ]);
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleApprove = (id) => {
    // TODO: Call backend approve endpoint
    setData(prev => prev.map(r => r.id === id ? { ...r, status: 'approved' } : r));
    message.success('Registration approved');
  };

  const handleReject = (id) => {
    // TODO: Call backend reject endpoint
    setData(prev => prev.map(r => r.id === id ? { ...r, status: 'rejected' } : r));
    message.success('Registration rejected');
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 100 },
    { title: 'Agency Name', dataIndex: 'name', key: 'name' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Submitted', dataIndex: 'submitted_at', key: 'submitted_at' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => {
        const color = s === 'approved' ? 'green' : s === 'rejected' ? 'red' : 'orange';
        return <Tag color={color}>{s}</Tag>;
      }
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Popconfirm
            title="Approve this registration?"
            onConfirm={() => handleApprove(record.id)}
            okText="Approve"
          >
            <Button size="small" type="primary" disabled={record.status !== 'pending'}>
              Approve
            </Button>
          </Popconfirm>
          <Popconfirm
            title="Reject this registration?"
            onConfirm={() => handleReject(record.id)}
            okText="Reject"
          >
            <Button size="small" danger disabled={record.status !== 'pending'}>
              Reject
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[
        { title: 'Admin' },
        { title: 'Agencies' },
        { title: 'Approve/Reject Registration' },
      ]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Approve/Reject Registration</Title>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>
          This is a placeholder page. Connect actions to your backend to approve/reject applications.
        </Paragraph>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{ pageSize: 10 }}
        />
      </Card>
    </div>
  );
};

export default AgencyRegistrations;
